<template>
  <el-tag :type="tagType" @click="$emit('click')">{{ description }}</el-tag>
</template>

<script>
import { DOCUTAX_SUBMISSION_STATUS, DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP } from '@/enum/DocutaxSubmissionStatus';

// maps a state to a tag type
const TYPE_MAP = {};
TYPE_MAP[DOCUTAX_SUBMISSION_STATUS.NEW] = '';
TYPE_MAP[DOCUTAX_SUBMISSION_STATUS.IN_PROGRESS] = 'info';
TYPE_MAP[DOCUTAX_SUBMISSION_STATUS.COMPLETE] = 'success';

export default {
  props: {
    status: {
      type: String,
    },
  },
  computed: {
    tagType() {
      return TYPE_MAP[this.status];
    },
    description() {
      return DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP[this.status];
    },
  },
};

</script>
